import { render, staticRenderFns } from "./HcpAdhdPopup.vue?vue&type=template&id=f566c174&scoped=true"
import script from "./HcpAdhdPopup.vue?vue&type=script&lang=js"
export * from "./HcpAdhdPopup.vue?vue&type=script&lang=js"
import style0 from "./HcpAdhdPopup.vue?vue&type=style&index=0&id=f566c174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f566c174",
  null
  
)

export default component.exports